import React from 'react';
import seta from '../../assets/img/seta.png';
import './BackToTop.css';
import ScrollTo from '../../helpers/scroll';

export class BackToTop extends React.Component {

    constructor(props) {
        super(props);
        this.handlescrollToTop = this.handlescrollToTop.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.state = {
            visible: false
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);

    }

    handleScroll(e) {
        var top = window.pageYOffset || document.documentElement.scrollTop
        if (top > 2000) {
            this.setState({ visible: true });
        }
        else {
            this.setState({visible:false});
        }
    }

    handlescrollToTop() {
        ScrollTo('Header')
    };

    render() {
        const { visible } = this.state;
        return (
            <a style={ visible ? { display: 'flex', transition:'500ms linear' } :{}} onClick={this.handlescrollToTop} className="backtotop">
                <img src={seta} alt="seta" />
            </a>
        );
    }
}

export default BackToTop;


// WEBPACK FOOTER //
// ./src/components/BackToTop/BackToTop.js